import { Note } from '../../../utils/note'
import { FilterConfig, FilterItem, TaskItem } from '../types'
import { useSidebarProvider } from '../../../contexts/Sidebar'
import {
  UniversalItemRenderer,
  NoteItemRenderer,
} from '../../../components/shared/BlockRenderer'
import { createFilterTaskItem } from '../../../components/shared/BlockRenderer/utils'
import { useMemo } from 'react'

type ItemComponentProps = {
  item: FilterItem
  filterConfig: FilterConfig
}

// Main component that handles FilterItem
export default function ItemComponent({
  item,
  filterConfig,
}: ItemComponentProps) {
  const { handleRevealNote } = useSidebarProvider()

  // Move useMemo to top level to avoid conditional hook usage
  const renderableItem = useMemo(() => {
    if (item.type === 'task') {
      // For individual tasks, use the groupKey as context (which contains the date when grouped by date)
      const context = item.groupKey
      return createFilterTaskItem(item.data as TaskItem, context)
    }
  }, [item])

  // For notes, use the specialized NoteItemRenderer that shows note header + tasks
  return item.type === 'note' ? (
    <NoteItemRenderer
      note={item.data as Note}
      filterConfig={filterConfig}
      onRevealNote={handleRevealNote}
      variant='filter'
    />
  ) : (
    // For individual tasks, use the UniversalItemRenderer
    renderableItem && (
      <UniversalItemRenderer
        item={renderableItem}
        variant='filter'
        showNoteHeader={false}
        showTaskToggle={true}
      />
    )
  )
}
